import axios from "axios";
import { environment } from "../../../environments/environment";
import { json } from "react-router-dom";

export function getAwbInfo(awbList) {
    return axios.post(`${environment.getAwbInfo}`, awbList);
}

export function getOrders(awb) {
    return axios.post(`${environment.getOrders}`, [{ "columnName": "awbNumber", "value": awb }, { "columnName": "companyId", "value": localStorage.getItem("u_company_id") }]);
}

export function getBoxes(awbId) {
    return axios.get(`${environment.getBoxes}?awbNumberId=${awbId}`);
}

export function loadImage(imageId) {
    return axios.get(`${environment.getImage}?fileId=${imageId}&containerName=awb-boxes`, { responseType: "arraybuffer" }).then(response => {
        const mimeType = response.headers['content-type'];
        const uint8Array = new Uint8Array(response.data);
        let binary = '';
        for (let i = 0; i < uint8Array.length; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        const base64 = btoa(binary);
        const dataURI = `data:${mimeType};base64,${base64}`;
        return {...response, data: dataURI};
    })
}

export function saveBoxReq(box, awb, awbId) {
    const formData = new FormData();
    for (const key in box) {
        if (box.hasOwnProperty(key)) {
            const value = box[key];
            if (Array.isArray(value) && value.length > 1 && value[0].file instanceof File) {
                value.forEach(file => {
                    formData.append(`${key}`, file.file);
                })
            } else if (Array.isArray(value) && value.length === 1 && value[0].file instanceof File) {
                formData.append(key, value[0].file);
            } else {
                formData.append(key, value)
            }
        }
    }
    return axios.post(`${environment.saveBox}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function intakeAWBReq(awbObj) {
    return axios.post(environment.saveAwbObj, awbObj);
    // return Promise.resolve({data: {responseCode: 200}});
}

export function getAwbObj(awb) {
    return axios.post(environment.getAwbObj, [awb]);
}